import { render, staticRenderFns } from "./DClean.vue?vue&type=template&id=46c5eb44&scoped=true&"
import script from "./DClean.vue?vue&type=script&lang=js&"
export * from "./DClean.vue?vue&type=script&lang=js&"
import style0 from "./DClean.vue?vue&type=style&index=0&id=46c5eb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c5eb44",
  null
  
)

export default component.exports